import {
    Avatar,
    Chip,
    FormControl,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    Typography,
} from "@material-ui/core"
import { Add, Payment, Remove } from "@material-ui/icons"
import { useContext, useState } from "react"

import { useEffect } from "react"
import { CalculosContext } from "../../../contexts/CalculosContext"
import useParametros from "../../../contexts/ParametrosContext"
import SiteContext from "../../../contexts/SiteContext"

const useStyles = makeStyles(theme => ({
    promocao_container: {
        display: "flex",
        justifyContent: "space-around",
    },
    promocao_porcentagem: {
        padding: "0px",
    },
    promocao_icone: {
        [theme.breakpoints.down("xs")]: {
            display: "none",
        },
        color: "#fff!important",
    },
    formaPagamento_container: {
        display: "flex",
        flexDirection: "row",
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            padding: "4px 8px",
        },
        flexGrow: "1",
        // gap: '12px',
        margin: "12px 0 8px 0", //'12px 0 8px 0',
        // padding: '4px',
        // border: 'rgba(0, 0, 0, 0.23) solid 1px',
        // borderRadius: '4px',
        justifyContent: "space-between",
        alignItems: "center",
        border: "1px rgba(0, 0, 0, 0.23) solid",
        borderRadius: "4px",
    },
    formaPagamento_modalidadePagamento: {
        width: "50%",
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            marginBottom: "16px",
        },
    },
    formaPagamento_grupoModalidades: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "row",
            width: "100%",
        },
    },
    formaPagamento_modalidade: {
        margin: "0px",
        alignSelf: "start",
        ["@media (max-width:450px)"]: {
            width: "100%",
        },
    },
    formaPagamento_formaPagamento: {
        margin: "0.5rem 0 0.25rem 0",
        minWidth: "50%",
        flex: 1,
    },
    formaPagamento_itemLista: {
        height: "2.5em",
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "nowrap",
    },
    formaPagamento_nome: {
        maxWidth: "80%",
        overflow: "hidden",
    },
    selecao: {
        "& > div": {
            display: "flex",
            justifyContent: "space-between",
            placeItems: "center",
            minHeight: "3.5em",
            padding: "0px 24px 0px 0px",
            marginLeft: "0.5rem",
        },
    },
}))

function getDefaultFormaPagamento(cardapio, carrinho, parametros) {
    if (!cardapio || !cardapio.formasPagamento) return undefined

    if (cardapio.formasPagamento.length === 1) return cardapio.formasPagamento[0]

    if (!parametros.PUBLIC_DESATIVAR_FORMA_PAGAMENTO_PADRAO) {
        const idFormaPadrao = parametros.PUBLIC_ID_FORMA_PAGAMENTO_PADRAO
        const formaPadrao = cardapio.formasPagamento.find(forma => forma.id === idFormaPadrao ?? 88)

        if (formaPadrao) return formaPadrao
    }

    return cardapio.formasPagamento.find(
        forma => forma.descricao === carrinho.formaPagamentoDescricao
    )
}

export default function SelecaoFormaDePagamento({
    setOpenTroco,
    isUsuarioPedidoMesa,
    isRetiradaNoLocal,
    aplicativoDados,
    isComerNoLocal,
    setAbrirDialogCadastroCartao,
}) {
    const { carrinho, cardapio } = useContext(SiteContext)
    const { calcularValorTotal } = useContext(CalculosContext)

    const classes = useStyles()
    const parametros = useParametros()

    const [formaDePagamento, setFormaDePagamento] = useState(
        getDefaultFormaPagamento(cardapio, carrinho, parametros)
    )
    const [formasDePagamento] = useState(cardapio.formasPagamento)

    useEffect(() => {
        handleSelecaoFormaDePagamento(getDefaultFormaPagamento(cardapio, carrinho, parametros))
    }, [])

    useEffect(() => {
        if (isComerNoLocal && !aplicativoDados.permiteEscolherPagamentoMesa)
            handleSelecaoFormaDePagamento(undefined)
    }, [isComerNoLocal])

    const handleSelecaoFormaDePagamento = async forma => {
        setFormaDePagamento(forma)
        const formaPagamentoSelecionado = forma

        if (!formaPagamentoSelecionado) {
            carrinho.pedido.formaPagamento = {}
            carrinho.pedido.troco = 0

            delete carrinho.formaPagamentoDescricao
            delete carrinho.pedido.cartaoCreditoCliente
            delete carrinho.descontoFormaPagamento
            delete carrinho.pedido.descontoFormaPagamento

            calcularValorTotal({
                carrinho,
                cardapio,
            })

            return
        }

        carrinho.formaPagamentoDescricao = formaPagamentoSelecionado.descricao
        carrinho.pedido.formaPagamento = formaPagamentoSelecionado
        carrinho.pedido.troco = 0
        window.dispatchEvent(
            new CustomEvent("escolheuFormaPagamento", {
                detail: {
                    payment_type: formaPagamentoSelecionado.descricao,
                    value: carrinho.pedido.valorTotal,
                    coupon: carrinho.cupomDesconto?.codigoCupom,
                },
            })
        )
        if (formaPagamentoSelecionado.id === 123 || formaPagamentoSelecionado.id === 71) {
            setAbrirDialogCadastroCartao(true)
        } else if (
            formaPagamentoSelecionado.id === 1 &&
            !isUsuarioPedidoMesa &&
            parametros.PUBLIC_ID_FORMA_PAGAMENTO_PADRAO !== "1"
        ) {
            setOpenTroco(true)
        }

        if (formaPagamentoSelecionado.id !== 40) {
            carrinho.pedido.cartaoCreditoCliente = null
            carrinho.pedido.tokenCartaoCredito = null
        }

        calcularValorTotal({
            carrinho,
            cardapio,
        })
    }

    if (
        !formasDePagamento?.length ||
        ((isUsuarioPedidoMesa || (isRetiradaNoLocal && isComerNoLocal)) &&
            !aplicativoDados.permiteEscolherPagamentoMesa)
    )
        return <></>

    return (
        <FormControl className={classes.formaPagamento_formaPagamento} fullWidth variant="outlined">
            <InputLabel>Forma de Pagamento</InputLabel>
            <Select
                label="Forma de Pagamento"
                fullWidth
                value={formaDePagamento}
                onChange={e => handleSelecaoFormaDePagamento(e.target.value)}
                className={classes.selecao}
            >
                {formasDePagamento.map(forma =>
                    forma.ativo ? (
                        <MenuItem
                            key={forma.id}
                            value={forma}
                            className={classes.formaPagamento_itemLista}
                        >
                            <div className={classes.formaPagamento_nome}>
                                {forma.urlImagem ? (
                                    <img
                                        src={forma.urlImagem}
                                        alt={forma.descricao}
                                        className="bandeiraCartao"
                                    />
                                ) : (
                                    <Payment className="bandeiraCartao" />
                                )}
                                {forma.descricao}
                            </div>
                            {forma?.desconto ? (
                                <Chip
                                    className={classes.promocao_container}
                                    style={{
                                        backgroundColor: forma.desconto > 0 ? "#28a745" : "#dc3545",
                                    }}
                                    size={window.screen.width > 600 ? "medium" : "small"}
                                    avatar={
                                        <Avatar
                                            className={classes.promocao_icone}
                                            style={{
                                                backgroundColor:
                                                    forma.desconto > 0 ? "#28a745" : "#dc3545",
                                            }}
                                        >
                                            {forma.desconto > 0 ? <Remove /> : <Add />}
                                        </Avatar>
                                    }
                                    label={
                                        <Typography
                                            component="span"
                                            variant="subtitle1"
                                            className={classes.promocao_porcentagem}
                                        >
                                            {Math.abs(forma.desconto)}%
                                        </Typography>
                                    }
                                />
                            ) : null}
                        </MenuItem>
                    ) : null
                )}
            </Select>
        </FormControl>
    )
}
